/* src/app/views/product-create-search/new-coverage/new-coverage.component.scss */
.container {
  background: #ffffff;
  -webkit-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  -moz-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  box-shadow: 1.5px 3px 5px 1.5px rgb(184, 175, 184);
}
.container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  float: left;
  margin-top: 20px;
}
.btn-save {
  width: 137px;
  height: 48px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 20px;
  margin-right: 20px;
}
.btn-save-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.btn-save:hover {
  background: #044ea7;
}
.btn-return {
  width: 137px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 20px;
  margin-right: 60px;
}
.btn-return-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.btn-return:hover {
  background: #044ea7;
}
button.btn-return:hover .btn-return-label {
  color: #ffffff;
}
@media only screen and (max-width: 900px) {
  .title {
    margin-left: 20px;
  }
  .space-first,
  .space-second,
  .space-third,
  .space-fourth {
    margin-left: 0;
  }
  .button-position {
    margin-left: 10px;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
  }
  .btn-return {
    margin-right: 20px;
  }
  .btn-save {
    margin-right: 10px;
  }
}
@media only screen and (max-width: 600px) {
  .button-position {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
    width: 100%;
    margin-left: 0;
    padding-bottom: 20px;
  }
  .btn-save,
  .btn-return {
    width: 100px;
    height: 40px;
    font-size: 13pt;
    margin-top: 10px;
    margin-right: 0;
  }
  .btn-return {
    margin-right: 10px;
  }
  .btn-save-label,
  .btn-return-label {
    font-size: 13pt;
  }
}
.container {
  width: 100%;
  max-width: none;
  margin: 0 0 24px;
  box-sizing: border-box;
  border-radius: 6px;
  overflow: visible;
}
.title {
  margin-left: 48px;
}
.container-body {
  margin-top: 20px;
}
.new-product-itens {
  padding: 8px 36px 0;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.new-product-itens-lines {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  margin-right: -12px;
  margin-left: -12px;
  width: calc(100% + 24px);
}
.new-product-itens-lines > [class*=col-] {
  padding: 0 12px 16px;
}
.new-product-itens-lines > .element-add-edit,
.new-product-itens-lines > .element-option-select {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
}
.new-product-itens-lines > .field-wide {
  flex: 0 0 66.6667% !important;
  max-width: 66.6667% !important;
}
.new-product-itens-lines > .textarea-row {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.element-add-edit {
  display: flex;
  flex-direction: column;
  align-items: initial;
}
.element-add-edit-input {
  width: 100%;
  min-height: 40px;
}
.element-add-edit-label,
.element-add-edit-filter {
  margin-bottom: 8px;
}
.element-add-edit .p-dropdown,
.element-add-edit .ui-dropdown,
.element-add-edit .p-inputtext,
.element-add-edit .ui-inputtext {
  width: 100% !important;
  min-height: 40px;
}
textarea.large-text {
  width: 100% !important;
  min-height: 96px !important;
  height: 96px !important;
}
.char-counter {
  font-size: 12px;
  color: #999999;
  margin-top: 6px;
}
.field-hint {
  display: block;
  margin-top: 6px;
}
.space-first,
.space-second,
.space-third,
.space-fourth,
.top-space {
  margin-left: 0 !important;
  margin-top: 0 !important;
}
.actions-section {
  width: 100%;
}
.button-position {
  justify-content: flex-end;
  gap: 14px;
  margin: 20px auto 0;
  max-width: 1240px;
  padding: 22px 36px 40px;
}
.btn-save,
.btn-return {
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.selected-product-text {
  font-weight: 500;
  color: #333333;
}
.placeholder-text {
  color: #999999;
  font-style: italic;
}
.product-item {
  padding: 4px 0;
  display: flex;
  align-items: center;
}
.product-item span {
  font-size: 14px;
  color: #333333;
}
::ng-deep .p-autocomplete {
  width: 100%;
}
::ng-deep .p-autocomplete-input {
  width: 100%;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size: 14px;
}
::ng-deep .p-autocomplete-input:focus {
  outline: none;
  border-color: #046cea;
  box-shadow: 0 0 0 2px rgba(4, 110, 234, 0.1);
}
::ng-deep .p-autocomplete-input:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}
::ng-deep .p-autocomplete-panel {
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
::ng-deep .p-autocomplete-panel .p-autocomplete-items {
  padding: 4px 0;
}
::ng-deep .p-autocomplete-panel .p-autocomplete-item {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
}
::ng-deep .p-autocomplete-panel .p-autocomplete-item:hover {
  background-color: #f5f5f5;
}
::ng-deep .p-autocomplete-panel .p-autocomplete-item.p-highlight {
  background-color: #e8f4ff;
}
::ng-deep .p-autocomplete-dropdown {
  cursor: pointer;
}
@media only screen and (max-width: 900px) {
  .new-product-itens {
    padding: 8px 24px 0;
    max-width: 100%;
  }
  .button-position {
    padding: 20px 24px 28px;
    margin-left: 0;
  }
}
@media only screen and (max-width: 600px) {
  .new-product-itens {
    padding: 8px 16px 0;
  }
  .new-product-itens-lines > .element-add-edit,
  .new-product-itens-lines > .element-option-select,
  .new-product-itens-lines > .textarea-row {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .button-position {
    padding: 18px 16px 20px;
  }
}
.element-add-edit-label,
.element-add-edit-filter,
.element-option-select-filter {
  font-size: 1.0625rem;
  line-height: 1.35;
}
.char-counter,
.field-hint {
  line-height: 1.35;
}
::ng-deep .container .p-inputtext,
::ng-deep .container .p-dropdown-label,
::ng-deep .container .p-dropdown-item {
  font-size: 1rem;
  line-height: 1.4;
}
::ng-deep .container .p-message .p-message-text {
  font-size: 0.9375rem;
  line-height: 1.4;
}
/*# sourceMappingURL=new-coverage.component-AMIEUF7Z.css.map */
